var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceUpanimao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396.21 364.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:21px;}.cls-1{stroke:#ecf0f1;}.cls-2{stroke:#252d35;}.cls-3{fill:#ecf0f1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Localiza\\xE7\\xE3o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.33,398.43,754.52,386a44.74,44.74,0,0,0,8.26-13.5c10-26.73-6.8-56.84-37.22-58.23q-1.38-.06-2.82-.06c-17.24,0-27.76,7.23-34.17,16.27a45,45,0,0,0-7.92,23.26,49.43,49.43,0,0,0,11.81,35l30.88,36.19",
    transform: "translate(-581.42 -124.5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "seta"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M723.29,423.11l4.7,5.5c25.36,28.16,60.36,47.2,97.82,49.92,25.33,1.83,54.3-2.92,82.14-22.83,30.59-21.86,50.56-56.21,56.7-94.17,7-43.27,2.28-113.06-55.32-174.64a10.31,10.31,0,0,1,.62-14.55l2.91-2.63c7-6.37,4.85-18.2-3.94-21.45l-34.19-12.65c-7.05-2.61-14.23,3.52-13.11,11.19l5.6,38.11c1.48,10.05,9.38,17.35,16.57,10.44l3.62-4",
    transform: "translate(-581.42 -124.5)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Casa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.9,392.81l.63-94.22a23.54,23.54,0,0,0-11.16-20L736.26,212a26.17,26.17,0,0,0-27.8,0L603.18,278.53A23.54,23.54,0,0,0,592,298.35l-.09,152.47c0,13.16,11.21,23.83,25.05,23.84l47.06,0a43,43,0,0,0,27.82-10.09l12.19-12",
    transform: "translate(-581.42 -124.5)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Bolinha"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 141.87,
    cy: 231.43,
    r: 12.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceUpanimao);
export default __webpack_public_path__ + "static/media/PlaceUp animação.ff509b2e03b37e231779dba1bcef6451.svg";
export { ForwardRef as ReactComponent };